import "./styles.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import useAuthStore from "@/hooks/useAuthStore";
import useFetch from "@/hooks/useFetch";
import PhoneInput from "@/UI/inputs/PhoneInput";
import PasswordInput from "@/UI/inputs/PasswordInput";
import translations from "@/config/translations";

export default function LoginScreen() {
    const { lang } = useLangStore();
    const { setAuth } = useAuthStore();
    const navigate = useNavigate();
    const t = translations[lang ?? "ar"].login;

    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [password, setPassword] = useState("");

    const { data, loading, error, invoke } = useFetch("auth/login", { method: "POST" }, false);

    useEffect(() => {
        if (data?.success && data?.data?.token) {
            setAuth(data.data.token, data.data.client);
            navigate("/select-store");
        }
    }, [data]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        invoke({ data: { phone, password } });
    };

    return (
        <div className="login-screen">
            <div className="login-card">
                <img src="/images/icon.png" className="login-logo" alt="BrewApp" />
                <div className="login-header">
                    <p className="login-title">{t.title}</p>
                    <p className="login-subtitle">{t.subtitle}</p>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <PhoneInput value={phone} onChange={setPhone} placeholder={t.phone} disabled={loading} />
                    <PasswordInput value={password} onChange={setPassword} placeholder={t.password} disabled={loading} />
                    {error && <p className="login-error">{error}</p>}
                    <button className="login-btn" type="submit" disabled={loading || !phone || !password}>
                        {loading ? "..." : t.submit}
                    </button>
                </form>
            </div>
        </div>
    );
}
